import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=0a69e0fd&shadow"
import script from "./Panels.vue?vue&type=script&lang=js&shadow"
export * from "./Panels.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports